(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
var menu = document.getElementById('MobileMenu');
if (!menu) return;

var backdrop = document.querySelector('.nav-backdrop');
var lastFocus = null;

function opened() {
return menu.classList.contains('is-open');
}

function setExpanded(state) {
var btns = document.querySelectorAll('[data-menu-open]');
for (var i = 0; i < btns.length; i++) {
btns[i].setAttribute('aria-expanded', state ? 'true' : 'false');
}
}

function openMenu() {
if (opened()) return;
lastFocus = document.activeElement;
menu.classList.add('is-open');
if (backdrop) backdrop.classList.add('is-open');
setExpanded(true);
var first = menu.querySelector('a, button');
if (first) first.focus();
document.addEventListener('keydown', onKeydown);
}

function closeMenu() {
if (!opened()) return;
menu.classList.remove('is-open');
if (backdrop) backdrop.classList.remove('is-open');
setExpanded(false);
document.removeEventListener('keydown', onKeydown);
if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
}

/* Esc closes; Tab is trapped within the panel while open. */
function onKeydown(e) {
if (e.key === 'Escape' || e.keyCode === 27) {
closeMenu();
return;
}
if ((e.key === 'Tab' || e.keyCode === 9) && opened()) {
var f = menu.querySelectorAll('a[href], button:not([disabled])');
if (!f.length) return;
var first = f[0];
var last = f[f.length - 1];
if (e.shiftKey && document.activeElement === first) {
e.preventDefault();
last.focus();
} else if (!e.shiftKey && document.activeElement === last) {
e.preventDefault();
first.focus();
}
}
}

document.addEventListener('click', function (e) {
var t = e.target;
if (!t || !t.closest) return;
if (t.closest('[data-menu-open]')) {
e.preventDefault();
if (opened()) {
closeMenu();
} else {
openMenu();
}
return;
}
if (t.closest('[data-menu-close]')) {
e.preventDefault();
closeMenu();
return;
}
/* A tap on any menu link dismisses the panel (navigation still proceeds). */
if (opened() && t.closest('#MobileMenu a')) {
closeMenu();
}
});

/* Reset when growing to the desktop breakpoint. */
var mq = window.matchMedia('(min-width: 768px)');
function onBreakpoint() {
if (mq.matches) closeMenu();
}
if (mq.addEventListener) {
mq.addEventListener('change', onBreakpoint);
} else if (mq.addListener) {
mq.addListener(onBreakpoint);
}
})();

  } catch(e) { console.error(e); }
})();
})();
